import React, { useEffect, useState } from "react";
import TotalSurveyIcon from "../../assets/icons/TotalSurveyIcon.svg";
import TotalLiveSurveyIcon from "../../assets/icons/TotalLiveSurvey.svg";
import TotalCompleatSurvey from "../../assets/icons/TotalCompleateSurvey.svg";
import { useNavigate } from "react-router-dom";

import { useGlobalContext } from "../../Contexts/GlobalContext";
import { CustomTablePagination } from "../../Utlils";
import TableLoader from "../survey/surveyDetails/components/TableLoader";
import NoData from "../../components/NoData";
const Invoice = () => {
  const { allInvoices, allInvoicesConfig } = useGlobalContext();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});

  //GET LAST 10 YEARS:
  const [monthYear, setMonthYear] = useState({});
  async function getYears() {
    let tempArr = [];
    for (let i = 0; i <= 10; i++) {
      tempArr.push(new Date()?.getFullYear() - i);
    }
    let months = [
      { month: "January", value: 0 },
      { month: "February", value: 1 },
      { month: "March", value: 2 },
      { month: "April", value: 3 },
      { month: "May", value: 4 },
      { month: "June", value: 5 },
      { month: "July", value: 6 },
      { month: "August", value: 7 },
      { month: "September", value: 8 },
      { month: "October", value: 9 },
      { month: "November", value: 10 },
      { month: "December", value: 11 },
    ];
    setMonthYear((prev) => ({ ...prev, years: tempArr, months: months }));
  }
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // pagination function
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredTableData = allInvoices
    ?.filter((data) =>
      !filters?.month
        ? data
        : new Date(data?.invoiceDate)?.getMonth() == filters?.month
    )
    ?.filter((data) =>
      !filters?.year
        ? data
        : new Date(data?.invoiceDate)?.getFullYear() == filters?.year
    )
    ?.filter((data) =>
      !filters?.status
        ? data
        : data?.paymentStats?.toLowerCase() == filters?.status
    );
  useEffect(() => {
    getYears();
  }, []);

  // console.log(new Date(allInvoices?.[0]?.invoiceDate).getMonth());
  // console.log(filters);
  // console.log("allInvoices=>", allInvoices);
  return (
    <div className="w-full flex flex-col gap-6 py-6">
      <div className="w-full flex items-center justify-between pb-4 border-b border-gray-200">
        <div>
          <h1 className="text-[#0226BE] text-[28px] font-[600] mb-1">Invoices & Billing</h1>
          <p className="text-gray-600 text-[14px]">View and manage your invoices</p>
        </div>

        {/* {allInvoices.length ? (
          <button
            className="bg-[#0226BE] text-[#fff] py-2 px-4 rounded-lg text-[14px] font-[600]"
            onClick={(e) => {
              // navigate("/payment");
              window.location.href =
                "https://buy.stripe.com/cN24hX3hHbe74Mg6oq?prefilled_email=sohrab.singh%40peekator.com";
            }}
          >
            Pay All Due Invoices
          </button>
        ) : (
          ""
        )} */}
      </div>
      {/* stats cards */}
      <div className="w-full grid grid-cols-3 gap-6">
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <img src={TotalSurveyIcon} alt="" className="w-6 h-6" />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allInvoices?.length || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Total Invoices
            </p>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-green-50 flex items-center justify-center flex-shrink-0">
            <img src={TotalLiveSurveyIcon} alt="" className="w-6 h-6" />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allInvoices?.filter(
                (d) => d?.paymentStats?.toLowerCase() === "paid"
              )?.length || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Paid Invoices
            </p>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center flex-shrink-0">
            <img src={TotalCompleatSurvey} alt="" className="w-6 h-6" />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allInvoices?.filter(
                (d) => d?.paymentStats?.toLowerCase() === "unpaid"
              )?.length || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Unpaid Invoices
            </p>
          </div>
        </div>
      </div>
      {/* filters row */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <select
            className="h-[44px] px-4 pr-10 text-[#1a1a1a] text-[14px] font-[500] bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
            value={filters?.month || ""}
            onChange={(e) => {
              setFilters((prev) => ({ ...prev, month: e.target.value }));
            }}
          >
            <option value="">All Months</option>
            {monthYear?.months?.map((data, ind) => {
              return (
                <option value={data?.value} key={ind}>
                  {data?.month}
                </option>
              );
            })}
          </select>
          <select
            className="h-[44px] px-4 pr-10 text-[#1a1a1a] text-[14px] font-[500] bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
            value={filters?.year || ""}
            onChange={(e) => {
              setFilters((prev) => ({ ...prev, year: e.target.value }));
            }}
          >
            <option value="">All Years</option>
            {monthYear?.years?.map((data, ind) => {
              return (
                <option value={data} key={ind}>
                  {data}
                </option>
              );
            })}
          </select>
          <select
            className="h-[44px] px-4 pr-10 text-[#1a1a1a] text-[14px] font-[500] bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
            value={filters?.status || ""}
            onChange={(e) => {
              setFilters((prev) => ({ ...prev, status: e.target.value }));
            }}
          >
            <option value="">All Status</option>
            <option value="paid">Paid</option>
            <option value="unpaid">Unpaid</option>
          </select>
          {(filters?.month || filters?.year || filters?.status) && (
            <button
              className="text-[14px] text-[#0226BE] font-[500] hover:underline px-3"
              onClick={(e) => setFilters({})}
            >
              Clear filters
            </button>
          )}
        </div>
      </div>
      {/* table  */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        {allInvoicesConfig?.loading ? (
          <TableLoader />
        ) : allInvoicesConfig?.error ? (
          <div className="w-full h-[200px] flex items-center justify-center">
            <h1 className="text-gray-600">Something went wrong</h1>
          </div>
        ) : (
          <div className="w-full overflow-x-auto containerScroll">
            <table
              className="whitespace-nowrap text-left w-full"
              id="table-to-xls-DATA"
            >
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Invoice No.
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Total Completes
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Total Avg CPI
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Total Revenue
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Total Payable Amount
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Invoice Status
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Invoice Date
                  </th>
                </tr>
              </thead>
                <tbody>
                  {filteredTableData.length == 0 ? (
                    <td colSpan={8}>
                      <div className="py-10">
                        <NoData />
                      </div>
                    </td>
                  ) : (
                    (rowsPerPage > 0
                      ? filteredTableData?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : filteredTableData
                    )?.map((data, ind) => (
                      <tr
                        key={ind}
                        className="border-b border-gray-100 hover:bg-blue-50 transition-all cursor-pointer"
                        onClick={(e) => navigate(`${data?._id}`)}
                      >
                        <td className="px-4 py-4 text-[#1a1a1a] font-[500] text-[14px]">
                          {data?.invoiceNumber}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          {data?.invoiceTable?.reduce(
                            (acc, cur) => (acc += cur?.totalCompletes),
                            0
                          )}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          ${Number(
                            data?.invoiceTable?.reduce(
                              (acc, curr) => (acc += curr?.totalRevenue),
                              0
                            ) /
                              (data?.invoiceTable?.reduce(
                                (acc, cur) => (acc += cur?.totalCompletes),
                                0
                              ) || 1)
                          )?.toFixed(2)}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          ${Number(
                            data?.invoiceTable?.reduce(
                              (acc, cur) => (acc += cur?.totalRevenue),
                              0
                            )
                          )?.toFixed(2)}
                        </td>
                        <td className="px-4 py-4 text-gray-700 font-[400] text-[14px]">
                          USD {Number(
                            data?.invoiceTable?.reduce(
                              (acc, cur) => (acc += cur?.totalRevenue),
                              0
                            )
                          )?.toFixed(2)}
                        </td>
                        <td className="px-4 py-4">
                          {data?.paymentStats === "paid" ? (
                            <span className="inline-flex items-center px-3 py-1 bg-green-50 text-green-700 text-[12px] font-[500] rounded-full border border-green-200">
                              Paid
                            </span>
                          ) : data?.paymentStats === "unpaid" ? (
                            <span className="inline-flex items-center px-3 py-1 bg-orange-50 text-orange-700 text-[12px] font-[500] rounded-full border border-orange-200">
                              Unpaid
                            </span>
                          ) : data?.paymentStats === "cancelled" ? (
                            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-700 text-[12px] font-[500] rounded-full border border-gray-200">
                              Cancelled
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="px-4 py-4 text-gray-600 font-[400] text-[14px]">
                          {new Date(data?.invoiceDate)?.toLocaleDateString(
                            "en-US",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <CustomTablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  sx={{ fontSize: "10px" }}
                  count={filteredTableData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  componentsProps={{
                    select: {
                      "aria-label": "rows per page",
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </table>
            </div>
          )}
        </div>
    </div>
  );
};

export default Invoice;
